import { Input } from './Input';
import { Textarea } from './Textarea';
import { Password } from './Password';
import { Search } from './Search';
Input.Textarea = Textarea;
Input.Password = Password;
Input.Search = Search;
export { Textarea };
export default Input;
